<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <DefaultTmpl :mode="$appUtils.isMobile() ? 'mobile_search' : 'default'">
        <template v-slot:main>
            <head-utils title="Pesquisar Notas Fiscais"/>
            <breadcrumb :items="[{label: 'Pesquisar Notas Fiscais', path: 'invoices'}]"/>

            <modal size="medium"
                   v-show="invoiceToCancel.id"
                   id="ModalCancelInvoice">

                <template v-slot:header>
                    <h3 class="title">Cancelamento de Nota Fiscal</h3>
                </template>

                <template v-slot:body>
                    <div class="container">
                        <div class="form-row">
                            <div class="col-12">
                                <label class="required" for="invoiceSearchDestroyReason">Motivo do Cancelamento</label>
                                <select v-model="invoiceToCancel.cancel_code"
                                        id="invoiceSearchDestroyReason"
                                        :class="{'is-invalid': errors.cancel_reason}"
                                        class="form-control form-control-sm">
                                    <option :value="null">[SELECIONE]</option>
                                    <option v-for="i in cancelReasons"
                                            :value="i.code"
                                            :key="i.code">{{i.label}}</option>
                                </select>
                                <field-messages :errors="errors.cancel_reason"/>
                            </div>
                        </div>
                        <div class="form-row">
                          <div class="col-12">
                            <label class="required" for="invoiceSearchDestroyReason">Descrição do Cancelamento</label>
                            <textarea v-model="invoiceToCancel.cancel_description"
                                      id="invoiceSearchDestroyDescription"
                                      :class="{'is-invalid': errors.cancel_description}"
                                      class="form-control form-control-sm"
                                      placeholder="Descreva o motivo do cancelamento da nota."
                                      maxlength="255"/>
                            <field-messages :errors="errors.cancel_description"/>
                          </div>
                        </div>
                    </div>
                </template>
                <template v-slot:footer>
                  <button type="button"
                          @click="confirmCancel"
                          :disabled="(invoiceToCancel && !invoiceToCancel.cancel_code) || !invoiceToCancel.cancel_description || isCancelingInvoice"
                          class="btn btn-sm btn-danger">
                    <svg-icon :icon="isCancelingInvoice ? 'sync' : 'ban'" :svg-class="isCancelingInvoice ? 'refresh rotate-1-seg' : ''"/>
                    {{isCancelingInvoice ? 'Aguarde, cancelando...' : 'Cancelar'}}
                  </button>
                  <button type="button"
                          :disabled="isCancelingInvoice"
                          @click="invoiceToCancel.id = null"
                          class="btn btn-sm btn-dark">
                    <svg-icon icon="times"/>
                    Fechar
                  </button>
                </template>
            </modal>

            <form @submit.prevent.stop="submit">
                <ibox>
                    <template v-slot:title v-if="!$appUtils.isMobile()">
                        <h5>Filtros de Pesquisa</h5>
                    </template>

                    <template v-slot:content>
                        <div v-if="$appUtils.isDesktop() || filterMode" class="container-fluid-grid">
                            <div class="form-row" v-if="!$appUtils.isMobile() || filterMode">
                                <div class="col-md-3 col-12 form-group">
                                    <label for="invoiceSearchTaker">Nome</label>
                                    <input id="invoiceSearchTaker" type="text" class="form-control form-control-sm"
                                           v-model="search_params.taker_name"/>
                                </div>
                                <div class="col-md-2 col-6 form-group">
                                    <label for="invoiceSearchStart">Período</label>
                                    <div class="input-group input-group-sm">
                                        <input type="text"
                                               id="invoiceSearchStart"
                                               v-model="search_params.start"
                                               placeholder="Início"
                                               v-flatpickr
                                               class="form-control form-control-sm t-c plch-center n-m-r-right">
                                        <div class="input-group-append">
                                            <div class="input-group-text">
                                                <svg-icon icon="calendar-alt"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2 col-6 form-group">
                                    <label for="invoiceSearchEnd">&nbsp;</label>
                                    <div class="input-group input-group-sm">
                                        <input type="text"
                                               id="invoiceSearchEnd"
                                               v-model="search_params.end"
                                               placeholder="Fim"
                                               v-flatpickr
                                               class="form-control form-control-sm t-c plch-center n-m-r-right">
                                        <div class="input-group-append">
                                            <div class="input-group-text">
                                                <svg-icon icon="calendar-alt"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-5 form-group">
                                    <label>&nbsp;</label>
                                    <FileUpload url="/v1/invoices/upload_xml"
                                                :file-formats="['text/xml']"
                                                button-title="Importar XML"
                                                button-class="btn-sm btn-primary"
                                                @onFileUploaded="fileUploaded"
                                                @onFileUploadedFail="fileUploadedFail"
                                                multiple="true"/>
                                </div>
                            </div>
                        </div>

                        <div v-if="$appUtils.isMobile() && !filterMode">
                            <div v-for="i in search.entries" class="list-card" :key="i.id">
                                <span class="number f-w-700">{{i.number}}</span>
                                <div class="status"><img class="img" alt="Status Invoice" :src="imageUrl(i)"></div>
                                <span class="doc">{{i.document | formatDocument}}</span>
                                <span class="taker ellipsis">{{i.taker_name}}</span>
                                <span class="tot c-theme f-w-700">Total R$ {{i.total_value | formatMoney}}</span>
                                <span class="ir c-red f-w-700">IR R$ {{i.ir_value | formatMoney}}</span>
                                <span class="dt">{{i.date_of_issue | formatDate}}</span>
                                <div class="act">
                                    <button type="button"
                                            @click="viewPdf(i)"
                                            class="btn btn-sm"
                                            title="Ver PDF">
                                        <svg-icon icon="file-pdf"/>
                                    </button>
                                    <button type="button"
                                            class="btn btn-sm"
                                            @click="downloadFile(i, true)"
                                            title="Baixar PDF">
                                        <svg-icon :class="{'refresh rotate-1-seg': downloadingPdfIds[i.id]}" :icon="downloadingPdfIds[i.id] ? 'sync' : 'cloud-download-alt'"/>
                                    </button>
                                    <button type="button"
                                            class="btn btn-sm"
                                            @click="downloadFile(i, false)"
                                            title="Baixar XML">
                                        <svg-icon :class="{'refresh rotate-1-seg': downloadingXmlIds[i.id]}" :icon="downloadingXmlIds[i.id] ? 'sync' : 'file-xml'"/>
                                    </button>
                                    <button type="button"
                                            class="btn btn-sm"
                                            @click="redirectToReplace(i)"
                                            title="Substituir">
                                      <svg-icon icon="sync"/>
                                    </button>
                                    <button type="button"
                                            class="btn btn-sm"
                                            @click="loadCancelReasons(i)"
                                            title="Cancelar/Substituir">
                                        <svg-icon icon="ban"/>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div ref='end_grid' v-if="$appUtils.isMobile()">
                            <FabMenuCrud :is-open="!filterMode && isOpenFabMenu"
                                         url-new="/invoices/new"
                                         v-if="!filterMode"
                                         @onExpand="isOpenFabMenu = !isOpenFabMenu"
                                         @onFilter="(is) => {
                                         filterMode = is;
                                         isOpenFabMenu = false;
                                         }"/>

                            <div class="t-c">
                                <svg-icon v-if="searching" icon="sync" class="refresh load-more-crud"/>
                            </div>
                        </div>
                    </template>

                    <template v-slot:footer>
                        <div class="row" v-if="filterMode || !$appUtils.isMobile()">
                            <div class="col-sm-12 t-r">
                            <span class="btn-group btn-group-sm" role="group" aria-label="Comandos de Pesquisa">
                                    <button type="button" @click="reset" class="btn btn-secondary btn-sm"><svg-icon icon="sync"/> Limpar</button>
                                    <router-link to="/invoices/new" class="btn btn-dark btn-sm"><svg-icon icon="plus"/> Nova Nota</router-link>
                                    <button type="submit" class="btn btn-theme-1 btn-sm"><svg-icon icon="search"/> Pesquisar</button>
                                </span>
                            </div>
                        </div>
                        <div class="row" v-if="$appUtils.isDesktop()">
                            <div class="col-sm-12">
                                <br/>
                                <Pagination
                                        :page_size="search.per_page"
                                        :current_page="search.current_page"
                                        :total_entries="search.total_entries"/>

                                <Loading :visible="searching"/>
                                <table class="table table-hover table-striped table-sm table-bordered">
                                    <thead class="thead-dark thead-center">
                                    <tr>
                                        <th style="width: 40px"></th>
                                        <th style="width: 80px">Número</th>
                                        <th style="width: 150px">Documento</th>
                                        <th>Tomador</th>
                                        <th style="width: 80px">Valor</th>
                                        <th style="width: 80px">IR</th>
                                        <th style="width: 100px">Competência</th>
                                        <th style="width: 110px">Emissão</th>
                                    </tr>
                                    </thead>
                                    <tbody v-if="search && search.entries">
                                    <tr v-for="i in search.entries" :key="i.id" class="line-item">
                                        <td class="t-c c-p" :title="i.replaced_by_number !== '' ? i.replaced_by_number : null">
                                            <img class="img" :src="imageUrl(i)">
                                        </td>
                                        <td class="t-c c-p">{{i.number}}</td>
                                        <td class="t-c c-p">{{i.document | formatDocument}}</td>
                                        <td class="ellipsis c-p">{{i.taker_name}}</td>
                                        <td class="t-r c-p">{{i.total_value | formatMoney}}</td>
                                        <td class="t-r c-p">{{i.ir_value | formatMoney}}</td>
                                        <td class="t-c c-p">{{i.date_of_issue | formatDate}}</td>
                                        <td class="t-c p-r o-h">
                                            {{i.competence | formatDate}}
                                            <div class="actions btn-group btn-group-xs">
                                                <button type="button"
                                                        @click="viewPdf(i)"
                                                        class="btn btn-xs btn-secondary"
                                                        title="Ver PDF">
                                                    <svg-icon icon="file-pdf"/>
                                                </button>
                                                <button type="button"
                                                        class="btn btn-xs btn-dark"
                                                        @click="downloadFile(i, true)"
                                                        title="Baixar PDF">
                                                    <svg-icon :class="{'refresh rotate-1-seg': downloadingPdfIds[i.id]}" :icon="downloadingPdfIds[i.id] ? 'sync' : 'cloud-download-alt'"/>
                                                </button>
                                                <button type="button"
                                                        class="btn btn-xs btn-primary"
                                                        @click="downloadFile(i, false)"
                                                        title="Baixar XML">
                                                    <svg-icon :class="{'refresh rotate-1-seg': downloadingXmlIds[i.id]}" :icon="downloadingXmlIds[i.id] ? 'sync' : 'file-xml'"/>
                                                </button>
                                                <button type="button"
                                                        class="btn btn-xs btn-sunny-orange"
                                                        @click="redirectToReplace(i)"
                                                        :disabled="i.cancel_reason || !$appUtils.isEmpty(i.replaced_by_number)"
                                                        :title="i.cancel_reason || i.replaced_by_number ? 'Essa não pode ser cancelada ou substituída' :  'Substituir'">
                                                  <svg-icon icon="sync"/>
                                                </button>
                                                <button type="button"
                                                        class="btn btn-xs btn-danger"
                                                        @click="loadCancelReasons(i)"
                                                        :disabled="i.cancel_reason || !$appUtils.isEmpty(i.replaced_by_number)"
                                                        :title="i.cancel_reason || i.replaced_by_number ? 'Essa não pode ser cancelada ou substituída' : 'Cancelar'">
                                                    <svg-icon icon="ban"/>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>

                                <Pagination
                                        :page_size="search.per_page"
                                        :current_page="search.current_page"
                                        :total_entries="search.total_entries"/>
                            </div>
                        </div>
                    </template>
                </ibox>
            </form>
        </template>
        <template v-slot:footer>
            <BottomMenuMob v-if="$appUtils.isMobile() && !filterMode"/>
        </template>
    </DefaultTmpl>
</template>

<script>
    import Pagination from '@/components/Pagination'
    import CRUDSearch from '@/mixins/CRUDSearch'
    import {createNamespacedHelpers} from 'vuex'
    import BottomMenuMob from "../../components/particles/BottomMenuMob";
    import FabMenuCrud from "../../components/particles/FabMenuCrud";
    import Loading from "../../components/particles/Loading";
    const {mapActions, mapGetters} = createNamespacedHelpers('invoices');
    export default {
        name: "InvoicesSearch",
        components: {
            Loading,
            FabMenuCrud,
            Pagination,
            BottomMenuMob,
            FileUpload: () => import(/* webpackChunkName: "comp-file-upload" */ '@/components/FileUpload')
        },
        mixins: [
            CRUDSearch.mount('invoices')
        ],
        data() {
            return {
                isOpenFabMenu: false,
                isCancelingInvoice: false,
                downloadingPdfIds: {},
                downloadingXmlIds: {},
                errors: {},
                cancelReasons: [],
                cancelReason: null,
                invoiceToCancel: {
                    cancel_code: null,
                    cancel_description: null,
                },
            }
        },
        methods: {
            imageUrl(invoice) {
                if (!this.$appUtils.isEmpty(invoice.replaced_by_number)) {
                    return '/assets/images/refresh_24.png'
                } else if (invoice.cancel_reason) {
                    return '/assets/images/cancel_24.png'
                }

                return '/assets/images/ok_24.png'
            },
            getIntersectItemListener() {
                return this.$refs.end_grid;
            },
            fileUploaded() {
                this.$snotify.success('Notas fiscais importadas com sucesso.', this.$appStorage.getUser().name);
                this.$set(this.search_params, 't', new Date().getTime());
                this.submit();
            },
            fileUploadedFail(arg) {
                if (arg && typeof arg.error.data === 'object') {
                    let message = [];

                    Object.keys(arg.error.data).forEach(k => {
                        message.push(arg.error.data[k]);
                    });

                    this.$snotify.error(this.$t('common.tryContactSupport', {msg: message.join('\n')}), this.$appStorage.getUser().name);
                } else {
                    this.$snotify.error(this.$t('common.tryContactSupport', {msg: 'Ops... Aconteceu algum problema ao tentar importar notas fiscais.'}), this.$appStorage.getUser().name);
                }
            },
            viewPdf(e) {
                const params = new URLSearchParams({url: `/v1/invoices/view/pdf?id=${e.id}&d=inline`, name: `Nota Fiscal - ${e.number}.pdf`});
                this.$router.push({path: `/pdf-viewer?${params.toString()}`})
            },
            downloadFile(e, isPdf = true) {
                const url = ['/v1/invoices/view/'];
                const name = `Nota Fiscal - ${e.number.replace('/', '-')}.${isPdf ? 'pdf' : 'xml'}`;
                const property = isPdf ? 'downloadingPdfIds' : 'downloadingXmlIds';

                this.$set(this[property], e.id, true);

                if (isPdf) url.push('pdf?id=', e.id, '&d=inline');
                else url.push('xml?id=', e.id);

                this.$appUtils.downloadFile(url.join(''), (isPdf ? 'application/pdf' : 'text/xml'), name)
                    .catch(err => {
                        this.$snotify.error(this.$t('common.downloadFileError'), this.$appStorage.getUser().name);
                        console.error(err);
                    })
                    .finally(() => setTimeout(() => this.$set(this[property], e.id, false), 1000));
            },
            loadCancelReasons(invoice) {
                if (this.cancelReasons.length === 0) {
                    this.$appHttp.get('/v1/invoices/load_cancel_reasons')
                        .then(({data}) => {
                            this.cancelReasons = data;
                            this.invoiceToCancel = {...invoice, cancel_code: null};
                        })
                        .catch(err => {
                            this.$appUtils.vibrate();

                            console.error('Load cancel reasons fail', err);
                            this.$snotify.error(this.$t('common.tryContactSupport', {msg: 'Ops... Aconteceu algum problema ao tentar carregar os motivos de cancelamento da nota.'}), this.$appStorage.getUser().name);
                        });
                } else {
                    this.invoiceToCancel = {...invoice, cancel_code: null};
                }
            },
            redirectToReplace(invoice) {
              const params = new URLSearchParams({mode: "replace", invoice_id: invoice.id, invoice_number: invoice.number});
              this.$router.push({path: `/invoices/new?${params.toString()}`});
            },
            confirmCancel() {
                this.$store.commit('addModal', {
                    title: 'Confirmar',
                    size: 'small',
                    body: `Tem certeza que deseja cancelar a nota ${this.invoiceToCancel.number} ?`,
                    buttons: [{
                        type: 'ok',
                        class: 'btn btn-danger btn-sm',
                        method: id => {
                            this.$store.commit('destroyModal', id);
                            this.cancelInvoice();
                        }
                    }, {
                        type: 'close',
                        label: 'Não',
                        focus: true,
                        method: id => this.$store.commit('destroyModal', id)

                    }]
                })
            },
            cancelInvoice() {
              this.isCancelingInvoice = true;
                this.$appHttp.delete(`/v1/invoices/${this.invoiceToCancel.id}?cancel_code=${this.invoiceToCancel.cancel_code}&cancel_description=${this.invoiceToCancel.cancel_description}`)
                    .then(() => {
                        this.invoiceToCancel.id = null;
                        this.$snotify.success('Nota cancelada com sucesso!', this.$appStorage.getUser().name);
                        this.$set(this.search_params, 't', new Date().getTime());
                        this.submit();
                    })
                    .catch(({response}) => {
                        this.$appUtils.vibrate();
                        console.error('Cancel invoice fail', response);

                        if (response.status === 422) {
                            Object.keys(response.data).forEach(k => {
                                this.$set(this.errors, k, response.data[k]);
                            });
                            this.$snotify.warning('Verifique os dados informados', 'Validação');
                        } else {
                            this.$snotify.error(this.$t('common.tryContactSupport', {msg: 'Ops... Aconteceu algum problema ao tentar cancelar a nota.'}), this.$appStorage.getUser().name);
                        }
                    }).finally(() => this.isCancelingInvoice = false);
            }
        }
    }
</script>
<style lang="scss" scoped>
    .list-card {
        display: grid;
        width: 100%;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto;
        grid-template-areas: "number status" "taker taker" "doc dt" "tot ir" "act act";
        grid-gap: 5px;
        font-size: .8em;
        padding: 5px;

        &:not(:first-child) {
            border-top: 1px solid #e7eaec;
        }
        .number {
            grid-area: number;
        }
        .status {
            grid-area: status;
        }
        .doc {
            grid-area: doc;
        }
        .taker {
            grid-area: taker;
        }
        .tot {
            grid-area: tot;
        }
        .ir {
            grid-area: ir;
        }
        .dt {
            grid-area: dt;
        }
        .act {
            grid-area: act;
            .btn {
                background-color: #e5e5e5;
                svg {
                    color: #000;
                }
            }

            .btn:not(:last-child) {
                margin-right: 5px;
            }
        }
        .status, .dt, .ir, .act {
            text-align: right;
        }
    }
</style>
